export function historySlider() {
    $('.history-section').each(function () {
        const slider = $(this).find('.history-slider');
        const sliderNav = $(this).find('.history-slider-controls');
        slider.slick({
            slidesToScroll: 1,
            slidesToShow: 1,
            infinite: false,
            appendArrows: sliderNav,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 567,
                    settings: {
                        slidesToScroll: 2,
                        slidesToShow: 2,
                    }
                }
            ]
        })
    })
}


// WEBPACK FOOTER //
// ./assets/js/modules/historySlider.js